import ProgressBar from "components/ProgressBar";
import Text from "components/Text";
import { FC, memo } from "react";
import { HiBadgeCheck } from "react-icons/hi";
import { colors } from "theme/colors";
import { WithStyle } from "utils/WithStyle";
import {
    MileStone,
    MileStoneHeader,
    MileStoneIcon,
    ProfileStrengthBarWrapper,
} from "./ProfileStrengthBar.styled";
import { ProfileStrengthBarProps } from "./types";

const Component: FC<ProfileStrengthBarProps> = memo(
    ({ mileStones, progress = 0, ...props }) => {
        const mStones = [
            ...(mileStones || []),
            {
                label: "VERIFIED PROFILE",
                icon: <HiBadgeCheck />,
                isComplete: progress === 100,
                left: "93%",
            },
        ];
        return (
            <ProfileStrengthBarWrapper
                {...props}
                showMileStones={(mileStones && mileStones.length > 1) || false}
            >
                <ProgressBar
                    progress={progress}
                    height="12px"
                    width="100%"
                    color={colors.purple.primary}
                />
                {mStones &&
                    mStones.map((mileStone) => (
                        <MileStone
                            left={mileStone.left}
                            isVerifiedMileStone
                            isComplete={mileStone.isComplete}
                        >
                            <MileStoneHeader>
                                <Text variant="body2">{mileStone.label}</Text>
                            </MileStoneHeader>
                            <MileStoneIcon>{mileStone.icon}</MileStoneIcon>
                        </MileStone>
                    ))}
            </ProfileStrengthBarWrapper>
        );
    }
);

export const ProfileStrengthBar: FC<ProfileStrengthBarProps> & WithStyle =
    Object.assign(Component, {
        Style: ProfileStrengthBarWrapper,
    });
